import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { EdgeNode } from '@cast/types-omni';

import { getEdgeLocationNodesQueryKey } from 'hooks/queries/omni';
import { getNodesQueryKey } from 'hooks/queries/nodes';
import { useCurrentOrganization } from '@cast/infrastructure-organization';

type Args = {
  clusterId: string;
  edgeLocationId: string;
  edgeNodeConfig: EdgeNode;
};

export const useCreateEdgeNodeMutation = () => {
  const currentOrganization = useCurrentOrganization();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (args: Args) =>
      apiClient.omni.createEdgeNode({
        organizationId: currentOrganization.id,
        clusterId: args.clusterId,
        edgeLocationId: args.edgeLocationId,
        edge: args.edgeNodeConfig,
      }),
    onSuccess: (_, args) => {
      queryClient.invalidateQueries({
        queryKey: getNodesQueryKey({ clusterId: args.clusterId }),
      });
      queryClient.invalidateQueries({
        queryKey: getEdgeLocationNodesQueryKey(
          args.clusterId,
          args.edgeLocationId
        ),
      });
    },
  });
};
